import { INVENTORYANDSALES_URL,STORAGE_URL } from "utils/constants";
import { ENDPOINTS } from "utils/endpoints";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";

export const getItemGroupFilter = (async (itemGroupId) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.CustomersStoreApi.CustomersStore.ItemGroupFilter
,
    method: 'get',
    params:{
        groupLeafId:itemGroupId
        }
    
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)
export const getItemPropertyValuesFilter = (async (ItemPropertyId) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.BaseDefinitionAndSettingApi.ItemMainPropertyValues.dictionary,
    method: 'get',
    params:{
        ItemMainPropertyId:ItemPropertyId
        }
    
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)